import { MouseActions } from '../../../models';
import { ValidationErrorMessage } from '@custis/common';
import s from './EditableRow.module.less';
import { Popover } from 'antd';
import React, { FunctionComponent, MutableRefObject } from 'react';
import { RowValidationPopoverData } from './models';

type Props = {
  popoverData: RowValidationPopoverData;
  onCancel: () => void;
  onContinue: () => void;
  errorRef: MutableRefObject<HTMLDivElement | null>;
  cancelText?: string;
};
export const RowValidationPopover: FunctionComponent<Props> = ({
  popoverData,
  onCancel,
  onContinue,
  errorRef,
  cancelText = 'Удалить строку',
}) => {
  const visible = Boolean(popoverData);
  const firstError = popoverData?.errors?.[0];
  const hasError = Number(popoverData?.errors.length) > 0;
  const content = hasError ? (
    <ValidationErrorMessage {...{ onCancel, onContinue, errorRef, cancelText }}>{firstError}</ValidationErrorMessage>
  ) : undefined;

  return (
    <Popover trigger={MouseActions.Click} placement={'bottom'} {...{ content, visible }}>
      <div className={s.Substrate} />
    </Popover>
  );
};
